import React, { useState, useRef, useEffect } from 'react';
import { HexColorPicker } from 'react-colorful';
import { KeenIcon } from '@/components';

const getHexColor = (val) => '#' + val.padEnd(6, '0');

const ColorInput = ({ label, value, onChange }) => {
    const [inputValue, setInputValue] = useState(value.replace('#', ''));
    const [showPicker, setShowPicker] = useState(false);
    const pickerRef = useRef();
    const buttonRef = useRef();

    // ✅ Đồng bộ khi prop value thay đổi từ cha
    useEffect(() => {
        let hex = value.replace('#', '');
        // Nếu là mã màu hợp lệ (6 ký tự, không phải toàn số 0), giữ nguyên
        if (/^#[0-9a-fA-F]{6}$/.test(value) && hex !== '000000' && hex !== 'ffffff' && hex !== 'FFFFFF') {
            hex = hex.replace(/0+$/, '');
        }
        setInputValue(hex);
    }, [value]);

    const handleColorChange = (color) => {
        const cleanColor = color.replace('#', '');
        setInputValue(cleanColor);
        onChange(getHexColor(cleanColor));
    };

    const handleTextChange = (e) => {
        const val = e.target.value.replace(/[^0-9a-fA-F]/g, '').slice(0, 6);
        setInputValue(val);
        // Luôn truyền lên cha, luôn fill màu (dù chưa đủ 6 ký tự)
        onChange(getHexColor(val));
    };

    useEffect(() => {
        if (!showPicker) return;
        const handleClickOutside = (event) => {
            if (
                pickerRef.current &&
                !pickerRef.current.contains(event.target) &&
                buttonRef.current &&
                !buttonRef.current.contains(event.target)
            ) {
                setShowPicker(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showPicker]);

    return (
        <div className="relative pr-4">
            <label className="block font-semibold mb-1">{label}</label>
            <div className="flex items-center gap-2">
                <div
                    ref={buttonRef}
                    className="inline-flex items-center px-4 py-2 bg-gray-100 border border-gray-300 rounded-md space-x-2 cursor-pointer shadow-sm relative"
                    onClick={() => setShowPicker(true)}
                >
                    <div
                        className="w-5 h-5 rounded-md border border-gray-400"
                        style={{ backgroundColor: getHexColor(inputValue) }}
                    />
                    <input
                        type="text"
                        maxLength={6}
                        value={inputValue}
                        onChange={handleTextChange}
                        className="font-mono text-sm text-gray-700 bg-transparent border-none outline-none w-20"
                        style={{ textTransform: 'uppercase' }}
                    />
                </div>
            </div>
            {showPicker && (
                <div ref={pickerRef} className="absolute z-50 mt-2 left-0">
                    <HexColorPicker
                        color={getHexColor(inputValue)}
                        onChange={handleColorChange}
                    />
                </div>
            )}
        </div>
    );
};

export { ColorInput };
